import { useEffect } from 'react';
import { useRouteError } from 'react-router';
import { Button } from '@/components/ui/button';
import { isStaleBuildError, reloadForNewBuild } from '@/lib/stale-build';

/**
 * What a route says when it could not render: most often a page left open across a deploy,
 * asking for a chunk the new build no longer has, which reloads itself once
 * (`lib/stale-build.ts`). Anything else gets the same screen every failed load gets.
 *
 * Imported statically by the router, never lazily: the screen that reports a missing chunk must
 * not be a chunk itself.
 */
export default function RouteError() {
  const error = useRouteError();
  const stale = isStaleBuildError(error);

  useEffect(() => {
    if (stale) reloadForNewBuild();
  }, [stale]);

  if (!stale) console.error('route_error', error);

  return (
    <div className="ee-empty" role="alert">
      <p className="ee-empty__title">
        {stale ? 'The site has been updated' : 'This page didn’t load'}
      </p>
      <p>{stale ? 'Loading the new version.' : 'Check your connection and try again.'}</p>
      <Button variant="outline" onClick={() => location.reload()} data-ee-feature="route.error.reload">
        Reload
      </Button>
    </div>
  );
}
